export default __webpack_public_path__ + "static/media/FoodChain_00.c09b5665.png";